import styles from './ContactUsDealerInformationSectionStoreInfo.module.scss';
import { CatTextPassage } from '@blocks-react/components/TextPassage';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import ContactUsDealerInformationSectionStoreHours from './../ContactUsDealerInformationSectionStoreHours';
import { useTranslation } from 'react-i18next';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatIconPhone } from '@blocks-react/components/Icons/Phone';
import { CatTextLink } from '@blocks-react/components/TextLink';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import { useBreakpoint } from '@app/hooks';
import { STATIC_PHONE_NUMBER } from '../../constants';

const ContactUsDealerInformationSectionStoreInfo = () => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const [t] = useTranslation();

  const isCatCorp = useSelector(s => s.common?.isCatCorp) || false;
  const helpCenterEnabled =
    useSelector(state => state.featureFlag?.PCCCustomerSupportHelpCenter) ||
    false;
  const dynamicPhoneNumber = useSelector(s => s.store?.phone);
  const phoneNumber =
    isCatCorp || helpCenterEnabled ? STATIC_PHONE_NUMBER : dynamicPhoneNumber;

  const dealerName = useSelector(s => s.dealer?.dealerName);
  const {
    name: storeName,
    storeHours = [],
    city,
    state,
    address,
    phone,
    zipcode
  } = useSelector(s => s.store);

  return (
    <div className="cat-u-padding-md">
      <div className="d-flex flex-column">
        <CatTextPassage style={{ gap: '0.25rem' }} size="sm">
          <p
            className={cx(
              styles[
                'contactUsPage__dealerInformationSection__content__description'
              ],
              'cat-u-margin-none'
            )}
          >
            {dealerName && (
              <>
                {dealerName}
                {storeName && ', ' + storeName}
                {address && (
                  <>
                    <br />
                    {address}
                  </>
                )}
                {state && (
                  <>
                    <br />
                    {city && city + ', '}
                    {state}
                    {zipcode && ' ' + zipcode}
                  </>
                )}
                {phone && isMD && (
                  <>
                    <br />
                    {phone}
                  </>
                )}
              </>
            )}
            {!dealerName && t('NO_DEALER_SELECTED')}
          </p>
        </CatTextPassage>

        {dealerName && storeHours.length > 0 && isMD && (
          <ContactUsDealerInformationSectionStoreHours
            storeHours={storeHours}
          />
        )}
        <div
          className="cat-u-margin-top-md cat-u-hide-md"
          data-testid={phoneNumber}
        >
          <CatHeading level="h3" variant="title-sm">
            {t('TEXT_LOCAL_DEALER_SUPPORT')}
          </CatHeading>
          <CatTextLink
            href={`tel:${phoneNumber}`}
            size="sm"
            className="mt-2 d-block"
            style={{ lineHeight: 1 }}
          >
            <CatIconPhone className="mr-2" />
            {phoneNumber}
          </CatTextLink>
        </div>
      </div>
    </div>
  );
};

export default ContactUsDealerInformationSectionStoreInfo;
